/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Stale_RecordInputs */

const fr_reference_stale_record = /** @type {(inputs: Reference_Stale_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet élément a été modifié. Actualisez-le avant de réessayer.`)
};

const en_reference_stale_record = /** @type {(inputs: Reference_Stale_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This item has changed. Refresh it before trying again.`)
};

/**
* | output |
* | --- |
* | "This item has changed. Refresh it before trying again." |
*
* @param {Reference_Stale_RecordInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const reference_stale_record = /** @type {((inputs?: Reference_Stale_RecordInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Stale_RecordInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reference_stale_record(inputs)
	return fr_reference_stale_record(inputs)
});